import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
export class I18nService {
    constructor(translate) {
        this.translate = translate;
        this._languageChanged = new BehaviorSubject(localStorage.getItem('lng'));
        this.languageChanged = this._languageChanged.asObservable();
    }
    // setLang() {
    //     const browserLang: string = this.translate.getBrowserLang();
    //     const lng = browserLang.match(/en|ar/) ? browserLang : 'en'
    //     if (localStorage.getItem('lng')) {
    //         this.translate.use(localStorage.getItem('lng'));
    //         document.dir = localStorage.getItem('lng') == 'ar' ? 'rtl' : 'ltr'
    //     } else {
    //         this.translate.use(lng);
    //         localStorage.setItem('lng', lng);
    //         document.dir = lng == 'ar' ? 'rtl' : 'ltr'
    //     }
    // }
    setLang(language) {
        this._languageChanged.next(language);
    }
    getLang() {
        return this._languageChanged;
    }
}
I18nService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function I18nService_Factory() { return new I18nService(i0.ɵɵinject(i1.TranslateService)); }, token: I18nService, providedIn: "root" });
